// extracted by mini-css-extract-plugin
export default {"navItem":"nav_item_navItem__znNcg","link":"nav_item_link__jltln"};